import { Text } from '@chakra-ui/layout';
import { AspectRatio, Box, Button, Container, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const PresentationVideo: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      mt={12}
      bgImage="radial-gradient(87.42% 234.39% at -0.8% 0%, #F563FF 0%, rgba(8, 255, 255, 0.50) 10.76%, rgba(15, 255, 231, 0.35) 30%, rgba(255, 120, 147, 0.10) 55%, rgba(0, 5, 15, 0.00) 86%), linear-gradient(90deg, #000 0.17%, #000 99.8%)"
      bgRepeat="no-repeat"
      p={6}
      pb={12}
    >
      <Container maxW="1050px">
        <Text textAlign="center" color="white" fontSize="3xl" fontFamily="heading">
          Experience the{' '}
          <Text as="span" textDecoration="underline">
            u
          </Text>
          nderline difference:
        </Text>
        <Text textAlign="center" fontFamily="heading" color="white" fontSize="3xl" fontWeight="bold">
          {t('newEventPage.whiteGloveOurExclusive')}
        </Text>
        <Flex flexDirection={{ base: 'column', lg: 'row' }} alignItems="center" mt={8} gap={4}>
          <Box flex={1}>
            <AspectRatio width={{ base: '340px', sm: '490px' }} ratio={16 / 9}>
              <iframe
                src="https://player.vimeo.com/video/811138682"
                allow="fullscreen; picture-in-picture"
                title="Video"
              />
            </AspectRatio>
          </Box>
          <Flex mt={{ base: 4, lg: 0 }} gap={4} color="white" justifyContent="center" flexDirection="column">
            <Text>{t('newEventPage.whiteGloveDescriptionOne')}</Text>
            <Text>{t('newEventPage.whiteGloveDescriptionTwo')}</Text>
            <Link href="/events/white-glove-service">
              <Button variant="solid" alignSelf="flex-start" mt={6} rightIcon={<ArrowIcon />}>
                {t('newEventPage.whiteGloveButtonLabel')}
              </Button>
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
